import { images } from "../../../../constants";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CallIcon from "@mui/icons-material/Call";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useGetCompanyByIdQuery } from "../../../../features/user/userApiSlice";
import { useGetShopRatingQuery, useGetVendorLikeDislikeQuery, useGetSubscriptionPurchasesByShopQuery } from "../../../../features/shop/shopApiSlice";
import ReportIcon from "@mui/icons-material/Report";
import SettingsIcon from "@mui/icons-material/Settings";
import TimelineIcon from "@mui/icons-material/Timeline";
import CampaignIcon from "@mui/icons-material/Campaign";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import "./companySidebar.css";
import Qrmodal from "../../../../components/QRmodal/Qrmodal";
import StarIcon from "@mui/icons-material/Star";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Desmodal from "../../../../components/Des_Modal";
import { getAsset } from "../../../../helpers/helper";
const CompanySideBar = () => {
  const [showmodal, setShowmodal] = useState(false);
  const closemodal = () => setShowmodal(false);
  const { name } = useSelector((state) => state.user);
  const [companyData, setCompanyData] = useState();
    const [TLike, setTLike] = useState(null);
  const [TDislike, setTDislike] = useState(null);
  const [desshow, setDesshow] = useState(false);
  const [addrShow, setAddrShow] = useState(false);
  const [showAddrReadMore, setShowAddrReadMore] = useState(false);
  const addrRef = useRef(null);
  const [showrating, setShowrating] = useState();
  const handleClosedes = () => setDesshow(false);
  const handleShowdes = () => setDesshow(true);
  const handleCloseAddr = () => setAddrShow(false);
  const handleShowAddr = () => setAddrShow(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: companyRes } = useGetCompanyByIdQuery(id, { skip: !id });
  const { data: ratingRes } = useGetShopRatingQuery(id, { skip: !id });
  const { data: likeDislikeRes } = useGetVendorLikeDislikeQuery(id, { skip: !id });
  const { data: purchaseResponse, isLoading: isPurchaseLoading } = useGetSubscriptionPurchasesByShopQuery(id, { skip: !id });
  const nameUser = name?._id?.toString();
  const shopUserId = companyData?.userid?.toString();
  const isOwner = Boolean(nameUser && shopUserId && shopUserId === nameUser);

  useEffect(() => {
    if (companyRes?.success || companyRes?.data?.Company) {
      setCompanyData(companyRes?.data?.Company);
    }
  }, [companyRes]);

  useEffect(() => {
    if (ratingRes?.data?.averageRating !== undefined) {
      setShowrating(ratingRes?.data?.averageRating);
    }
  }, [ratingRes]);

  useEffect(() => {
    if (likeDislikeRes?.success && likeDislikeRes?.data?.length > 0) {
      const item = likeDislikeRes.data[0];
      setTLike(item.Tlike);
      setTDislike(item.Tdislike);
    }
  }, [likeDislikeRes]);

  useEffect(() => {
    const el = addrRef.current;
    const text = companyData?.companyaddress || "";
    if (!el || !text) {
      setShowAddrReadMore(false);
      return;
    }
    const checkOverflow = () => {
      setShowAddrReadMore(el.scrollHeight > el.clientHeight + 1);
    };
    checkOverflow();
    const ro =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(checkOverflow)
        : null;
    ro?.observe(el);
    window.addEventListener("resize", checkOverflow);
    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [companyData?.companyaddress]);

  localStorage.getItem("contactnumber");
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Click on address to view map
    </Tooltip>
  );
  return (
    <Row>
      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={companyData?.description}
      />
      <Desmodal
        desshow={addrShow}
        handleClosedes={handleCloseAddr}
        des={companyData?.companyaddress}
        title="Address"
      />
      <Qrmodal show={showmodal} handleClosemodal={closemodal} />
      <Col
        className="shop-profile-box pt-1 px-3 ms-0 me-0 screenHeight company-profile-sidebar"
        md={12}
        lg={12}
        style={{ height: "100vh" }}
      >
        <div
          className="d-flex justify-content-center pb-2"
          onClick={() => navigate("/update-company/" + id)}
        >
          <img className="w-img" src={images.UpdateShop} alt="UpdateShop" />
          <h6 className="mb-0 ps-2 pt-1 updateSize">Update Company Profile</h6>
        </div>
        <div>
          <img
            className="w-100 shop-profile-img"
            src={
              companyData?.image && companyData.image[0] && companyData.image[0] !== ""
                ? getAsset(companyData.image)
                : images.noprofile
            }
            alt=""
            crossOrigin={
              companyData?.image && companyData.image[0] && companyData.image[0] !== ""
                ? "anonymous"
                : undefined
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = images.noprofile;
            }}
          />
        </div>
        <div className="box-container mt-1">
          <Row>
            <Col lg="10" className="pe-0">
              <div className="pt-2 pb-1">
                <h4 className="shop-Profile-font mb-0 pb-1 ">
                  {companyData?.companyname}
                </h4>
                <Col lg="8">
                  <p className="shop-profile-para mb-0 d-flex">
                    <div>{companyData?.description?.slice(0, 15)}</div>
                    <div>
                      {companyData?.description?.length > 15 && (
                        <p
                          onClick={handleShowdes}
                          className="mb-0 cursor_P font_11 text-dark"
                          style={{ marginTop: "3px" }}
                        >
                          &nbsp;<b>ReadMore...</b>
                        </p>
                      )}
                    </div>
                  </p>
                </Col>
              </div>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div className="d-flex align-items-start company-sidebar-address">
                  <LocationCityIcon className="silver-icon mt-1" />
                  <div className="ps-2 flex-grow-1 min-w-0">
                    <p
                      ref={addrRef}
                      className="mb-0 ViewlabelText pt-1 pb-0 company-sidebar-address-text"
                    >
                      {companyData?.companyaddress}
                    </p>
                    {showAddrReadMore ? (
                      <button
                        type="button"
                        className="company-sidebar-read-more"
                        onClick={handleShowAddr}
                      >
                        Read more
                      </button>
                    ) : null}
                  </div>
                </div>
              </OverlayTrigger>
            </Col>
            <Col lg="2">
              <div className="d-flex justify-content-end">
                <QrCodeScannerIcon onClick={() => setShowmodal(true)} />
              </div>
            </Col>
          </Row>
        </div>
        {/* details */}
        <div>
          <div>
            <div className="d-flex">
              <div className="">
                <div className="d-flex align-items-center pt-1 pb-2">
                  <StarIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">{showrating}</p>
                </div>
                <div className="d-flex align-items-center pt-1 pb-2">
                  <CallIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">{name?.phonenumber}</p>
                </div>
                <div className="d-flex align-items-center pt-1 pb-2 ">
                  <ThumbUpIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Liked by {TLike} </p>
                </div>
                <div className="d-flex align-items-center pt-1 pb-2">
                  <ThumbDownIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Unliked by {TDislike} </p>
                </div>
                {/* <div className="d-flex align-items-center pt-1 pb-2">
                  <NotificationsIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Suggestions</p>
                </div> */}
                {/* <div
                  className="d-flex align-items-center cursor_P pb-2"
                onClick={() => setSuggest(2)}
                >
                  <ReportIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Report</p>
                </div> */}
                <div
                  className="d-flex align-items-center pb-2 cursor_P"
                  onClick={() => navigate(`/company-setting/${id}`)}
                >
                  <SettingsIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Setting</p>
                </div>
                <div
                  className="d-flex align-items-center pb-2 cursor_P"
                  onClick={() => {
                    const sid = companyData?._id || id;
                    if (sid) {
                      localStorage.setItem("OpenShopIdForMarketingByMarketer", sid);
                      localStorage.setItem("shopid", sid);
                    }
                    navigate(
                      sid ? `/shop-side-statistics/${sid}` : `/shop-side-statistics`
                    );
                  }}
                >
                  <TimelineIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">
                    View your marketing statistics
                  </p>
                </div>
                <div
                  className="d-flex align-items-center pb-2 cursor_P"
                  onClick={() =>
                    navigate(`/promote-shop/${companyData?.shopid || id}`)
                  }
                >
                  <CampaignIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">Ads and promotion</p>
                </div>
                {/* <div>
                  <h4>Available payment methods</h4>
                  <div className="d-flex justify-content-between">

                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {isOwner && (
          <div className="pt-1 pb-3">
            {isPurchaseLoading && (
              <div className="d-flex justify-content-center my-1 mb-4">
                <span className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            )}
            <button
              onClick={() =>
                navigate(`/add-consultancy-services-profile/${id}`)
              }
              className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
            >
              Add Consultancy Services
            </button>
            {!isPurchaseLoading && (
              <button
                onClick={() => {
                  const bt =
                    companyData?.businessType || "jobsCompany";
                  const sid = companyData?._id || id;
                  if (bt) localStorage.setItem("BTtogetMarketer", bt);
                  if (sid) localStorage.setItem("shopid", String(sid));
                  navigate("/hire-marketers");
                }}
                className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
              >
                Hire Us For Your Marketing & Ads
              </button>
            )}
          </div>
        )}
        {/* <div className="img-height">
          <img src={images.ShopProfile} alt="" className="h-100 w-100" />
        </div> */}
      </Col>
    </Row>
  );
};
export default CompanySideBar;
